export function columnFile(gotoQualificationFileApi) {
    const _this = this
    return {
        title:'资质文件',
        key: 'oss_path',
        align: 'center',
        width:80,
        render(h, { row }) {
          return h('Button', {
            props: {
              type:'info',
              size:'small',
              loading:row._loading
            },
            on:{
              click() {
                _this.$set(row, '_loading', true)
                gotoQualificationFileApi({
                  file_path:row.oss_path,
                  final() {
                    row._loading = false
                  }
                }).then(url => {
                  window.open(url, '_blank')
                })
              }
            }
          }, '查看')
        }
      }
}